module.exports = __webpack_public_path__ + "img/chicken-fall-t.4a90e04e.gif";